export default __webpack_public_path__ + "static/glosseta-3744d32e641459e05d8ad0711f4f9afc.jpg";